import styled from 'styled-components';

const StyledButton = styled.button`
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border-radius: 3px;
  cursor: pointer;
  width: 100%;
  max-width: 400px;

  h2 {
    text-align:center;
  }

  :hover {
    border: 2px solid ${props => props.theme.secondary}
  }

  /* Color the border and text with theme.main */
  color: ${props => props.theme.main};
  border: 2px solid ${props => props.theme.main};
`;

type ButtonProps = {
  text: string,
	disabled: boolean,
  onClick(): void
}

export const Button = ({ text, onClick, disabled = false }: ButtonProps) => {
  return (
    <StyledButton onClick={onClick} disabled={disabled}><h2>{text}</h2></StyledButton>
  )
}